import React from "react";
import './input.scss'

export class Input extends React.Component<any,any> {
    feedbackForm = { name: '' };
    constructor(props: any) {
        super(props);
        this.state = { value: '' }
    }

    componentDidMount() {
        this.setState({value: this.props.value})

    }
    handleChange(evt, field) {
        this.setState({ value: evt.target.value });
        this.props.onInputChange(evt.target.value,field);
    }
    render(): React.ReactNode {
        return (
            <div className="input__wrapper">
                <div className="floating-form">
                    <div className="floating-label">
                        <input className="floating-input" id="name" name={this.props.name} type={this.props.type} placeholder=" " value={this.state.value} onChange={(event) => this.handleChange(event, this.props.name)} maxLength={this.props.maxLength} minLength={this.props.minLength}/>
                        <span className="highlight"></span>
                        <label>{this.props.placeHolder}</label>
                    </div>
                </div>
            </div>
        )
    }
}

export default Input;